import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import store from './store'

import VueElementLoading from "vue-element-loading";
Vue.component("VueElementLoading", VueElementLoading);
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
import ServerError from './components/Common/500'
Vue.component('ServerError', ServerError)
Vue.config.productionTip = false
window.axios = require('axios')
    // axios.defaults.baseURL = 'http://192.168.51.144:3200';
    // Vue.prototype.mediaURL = "http://192.168.51.144:3200/u/"

// axios.defaults.baseURL = 'https://api.gurukultek.com';
// Vue.prototype.baseURL = "https://api.gurukultek.com"
// Vue.prototype.mediaURL = "https://api.gurukultek.com/u/"

axios.defaults.baseURL = 'http://52.66.213.94';
Vue.prototype.baseURL = "http://52.66.213.94"
Vue.prototype.mediaURL = "http://52.66.213.94/u/"
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')